import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { articleHandler, linkedValueHandler, formulaHandler } from "./handlers";
import { AttrDepsHandler } from "./AttrDepsHandler";

/* eslint no-await-in-loop: "off" */
/* eslint no-restricted-syntax: "off" */

const clone = <T>(attr: T) => JSON.parse(JSON.stringify(attr)) as T;

/**
 * Определение зависимостей атрибутов от других атрибутов внутри родительского объекта.
 * Также замена старых id на новые.
 */

const handlers: AttrDepsHandler[] = [
  articleHandler,
  linkedValueHandler,
  formulaHandler,
];

export class AttrDepsResolver {
  public deps: Record<ZUid, ZUid[]> = {};

  public attrForCopy = new Set<ZUid>();

  public attrSrcToDst: Record<ZUid, ZUid> = {};

  constructor(
    public readonly srcObjId: ZUid,
    public readonly dstObjId: ZUid,
    public readonly attrs: ZAttribute[],
  ) {}

  public async searchDeps(ids: ZUid[]) {
    for (const id of ids) {
      const attr = this.getAttrById(id);
      if (!this.deps[id] && attr) {
        this.attrForCopy.add(id);
        const result = await this.searchDepsSingle(attr);
        this.deps[id] = result;
        await this.searchDeps(result);
      }
    }
  }

  public async replaceDeps(attr: ZAttribute) {
    const attrClone = clone(attr);
    for (const handler of handlers) {
      await handler.replace(attrClone, this);
    }
    return attrClone;
  }

  public getAttrById(attrId: ZUid) {
    return this.attrs.find((attr) => attr.id === attrId);
  }

  public hasDepsFromList(attrId: ZUid, idList: ZUid[]) {
    const deps = this.deps[attrId];
    return idList.some((id) => deps?.includes(id));
  }

  private async searchDepsSingle(attr: ZAttribute) {
    const allIds = this.attrs.map(({ id }) => id);
    const idList: ZUid[] = [];
    const attrClone = clone(attr);
    for (const handler of handlers) {
      const result = await handler.search(attrClone, this);
      idList.push(...result);
    }
    return idList.filter((id) => allIds.includes(id));
  }
}
